import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Logotext, loader_image } from "../_components/Imagepath";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { base_url, Apitoken, Authtoken } from "../Global";
// import { generatePdf } from "../supplychainpackagelistheaders/DailyReportPDF";
// import html2canvas from 'html2canvas';
// import { saveAs } from 'file-saver';
import $ from "jquery";

// // import React from 'react';
// import html2pdf from 'html2pdf.js';
// import JsPDF from 'jspdf';
import { useRef } from 'react';

// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
// import Pdf from 'react-to-pdf';

const ViewInvoice = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  // const [apiData, setApiData] = useState([]);
  const ref = useRef();
  const [invtype, setInvtype] = useState(false);

  const [currencySymbol, setCurrencySymbol] = useState('');
  useEffect(() => {
    axios
      .get(`/invoices/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.invoice);
          if (response.data.data.invoice.invoice_type == 1) {
            setInvtype(true);
          }


          axios.get(`/helper/currency-by-customer/${response.data.data.invoice.customer_id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          }).then((response) => {
            if (response.data.code === 200) {
              // console.log(response.data.data);
              setCurrencySymbol(response.data.data.customer_currency)

            }
          }).catch((error) => {
            console.log(error);
          });

        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  // const Print = () =>{     
  //   //console.log('print');  
  //   let printContents = document.getElementById('printablediv').innerHTML;
  //   let originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //  document.body.innerHTML = originalContents; 
  // }
  // const handleDownload = () => {
  //   const element = document.getElementById('printablediv');

  //   html2canvas(element).then((canvas) => {
  //     // Convert the canvas to a data URL
  //     const dataURL = canvas.toDataURL();

  //     // Create a file name
  //     const fileName = 'download.png';

  //     // Save the data URL as a file
  //     saveAs(dataURL, fileName);
  //   });
  // };



  const handleDownloadPDF = async (value) => {
    var invoice_id = value.id;

    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/invoices/finance-sale-invoice/${invoice_id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const date = value.date || '';
      const invoicenumber = value.invoice_number || '';
      const company_name = value.customer?.company_name || 'Unknown';
      const company_name_supplier = value.customer?.name || 'Unknown';
      
      link.download = value.customer_type === 'invoice' ? `${date} ${company_name} ${invoicenumber}.pdf` : `${date} ${company_name_supplier} ${invoicenumber}.pdf`;

      link.click();
      $("#loader-image").addClass('loader-hide');
      $("#loader-image").removeClass('loader-show');
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  };

  const handleDownloadExcel = async (value) => {
    console.log(value);
    window.open(`${base_url}/invoices/manual-view-download-excel-open/${id}`, '_blank');

  };


  const handleDownloadPDFPackagingList = async (value) => {
    console.log(value);

    $("#loader-image-invoice2").removeClass('loader-hide');
    $("#loader-image-invoice").addClass('loader-show');
    var invoice_id = value.id;
    axios.get(`/invoices/view-download-pdf/${invoice_id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const customerName = value.customer?.company_name?.replace(/[^a-zA-Z0-9 ]/g, '') || 'Customer';
      const fileName = `${value.date} ${customerName} ${value.invoice_number}.pdf`;
      link.download = fileName;
      link.click();
      $("#loader-image-invoice2").addClass('loader-hide');
      $("#loader-image-invoice2").removeClass('loader-show');
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      });
  };
  const generatePdfInvoiceDownloadExcel = async (invoice) => {

    window.open(`${base_url}/invoices/view-download-excel-open/${invoice.id}`, '_blank');

  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">View {value.invoicetype
                    ? value.invoicetype.title
                    : "Invoice"}</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/invoices">{value.invoicetype
                        ? value.invoicetype.title
                        : "Invoice"}</Link>
                    </li>
                    <li className="breadcrumb-item active">View {value.invoicetype
                      ? value.invoicetype.title
                      : "Invoice"}</li>
                  </ul>
                </div>
                <div className="col-sm-2">
                  <div className="pull-right">

                    {value.packaging_list_id != 0 && (
                      <div style={{ display: 'flex' }}>
                        <button onClick={() => handleDownloadPDFPackagingList(value)} className="btn btn-primary me-1"  > Download PDF  <i className="fa fa-download" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image} />  </button>
                        <button onClick={() => generatePdfInvoiceDownloadExcel(value)} className="btn btn-primary me-1"  > Download Excel  <i className="fa fa-pdf" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image} />  </button>

                      </div>

                    )}

                    {value.packaging_list_id == 0 && (
                      <div style={{ display: 'flex' }}>
                        <button onClick={() => handleDownloadPDF(value)} className="btn btn-primary me-1"  >  Download {value.invoicetype
                          ? value.invoicetype.title
                          : "Invoice"}  <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image} />  </button>

                        <button onClick={() => handleDownloadExcel(value)} className="btn btn-primary me-1"  > Download Excel  <i className="fa fa-pdf" /> <img id="loader-image-invoice3" className="loader-image loader-hide" src={loader_image} />  </button>
                      </div>

                    )}



                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-12" id="printablediv">
                <div className="card" ref={ref} style={{ width: '100%' }}  >
                  <div className="card-body">

                    <div className="invoice-item">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="invoice-info">
                            <div className="invoice-logo1">
                              <img src={Logotext} alt="logo" style={{ width: '350px', height: '100px', }} />
                            </div>

                            <p className="invoice-details invoice-details-two">

                              Lot chaaban 1, N 557, Larache 92000, Morocco


                              <br />
                              Telephone number: 0678732391 <br />
                              <br />
                              Incoterms:{" "}
                              {value.customer && value.customer.incoterm_name
                                ? value.customer.incoterm_name.title
                                : ""}
                              <br />
                              Payment Terms:{" "}
                              {value.customer &&
                                value.customer.payment_terms &&
                                value.customer.payment_terms.delay1_description
                                ? value.customer.payment_terms.delay1_description
                                : ""}
                              <br />
                              Country of Origin:{"Morocco"}

                            </p>
                          </div>
                        </div>
                        <div className="col-md-4"></div>
                        {value.customer_type == 'invoice' ? (
                          <div className="col-md-4">
                            <div className="invoice-info invoice-info2">
                              <p className="invoice-details" style={{ textAlign: 'left' }}>
                                <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                                <br />
                                <strong>Date:</strong> {value.date}
                              </p>
                              <strong className="customer-text ">
                                {value.invoicetype
                                  ? value.invoicetype.title
                                  : "Invoice"} To
                              </strong>
                              <p className="">
                                {value.customer_id
                                  ? value.customer.company_name
                                  : ""}
                                <br />
                                {/* {value.invoicing_address
                                  ? value.invoice_address.email
                                  : ""}
                                <br /> */}
                                {value.invoicing_address
                                  ? value.invoice_address.phone_number
                                  : ""}  {', '}

                                {value.invoicing_address
                                  ? value.invoice_address.address
                                  : ""} {', '}

                                {value.invoicing_address
                                  ? value.invoice_address.city
                                  : ""} {', '}
                                {value.invoicing_address
                                  ? value.invoice_address.zip_code
                                  : ""}{', '}
                                {value.invoicing_address
                                  ? value.invoice_address.country_name
                                  : ""} {', '}


                              </p>

                              <p>
                                Incoterms:{" "}{value?.customer?.incoterm_name?.title || ""} {', '}

                                Payment Terms:{" "}
                                {value?.customer?.payment_terms?.delay1_description || ""}

                              </p>
                              <p>
                                {invtype && (
                                  <p>ICE:  {value.ice}</p>
                                )}
                                {invtype && (
                                  <p>IF: {value.if}</p>
                                )}
                              </p>

                            </div>
                          </div>
                        ) : (
                          <div className="col-md-4">
                            <div className="invoice-info invoice-info2">
                              <p className="invoice-details" style={{ textAlign: 'left' }}>
                                <strong>Invoice N°:</strong> {value.invoice_number}{" "}
                                <br />
                                <strong>Date:</strong> {value.date}
                              </p>
                              <strong className="customer-text ">
                                {value.invoicetype
                                  ? value.invoicetype.title
                                  : "Invoice"} To
                              </strong>
                              <p className="">
                                {value.customer
                                  ? value.customer.name
                                  : ""}<br />

                                {value.customer
                                  ? value.customer.phone_number
                                  : ""}<br />
                                {value.customer
                                  ? value.customer.address
                                  : ""}<br />



                                {invtype && (
                                  <p>ICE:  {value.ice}</p>
                                )}
                                {invtype && (
                                  <p>IF: {value.if}</p>
                                )}
                              </p>

                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="invoice-item invoice-table-wrap">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="invoice-table table table-bordered">
                              <thead>
                                <tr>
                                  {invtype === false && (
                                    <th>Product</th>
                                  )}

                                  {invtype && (
                                    <th>Description</th>
                                  )}
                                  <th className="text-center">Quantity (kg)</th>
                                  <th className="text-end">Price </th>
                                  <th className="text-end">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {value.items &&
                                  value.items.map((item) => (
                                    <tr key={item.id}>
                                      {invtype === false && (
                                        <td>  {item.producttype
                                          ? item.producttype.code
                                          : ""} {item.producttype
                                            ? item.producttype.title
                                            : ""}
                                        </td>
                                      )}



                                      {invtype && (
                                        <td className="">
                                          {item.calibre}
                                        </td>
                                      )}
                                      <td className="text-center">
                                        {item.quantity}
                                      </td>
                                      <td className="text-end">{item.price}{currencySymbol}</td>
                                      <td className="text-end">
                                        {item.amount}{currencySymbol}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-6 col-xl-4 ms-auto">
                          <div className="table-responsive">
                            <table className="invoice-table-two table">
                              <tbody>

                                <tr>
                                  <th>Amount:</th>
                                  <td>
                                    <span>{value.total_amount}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Tax:</th>
                                  <td>
                                    <span>{value.tax}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Discount:</th>
                                  <td>
                                    <span>{value.discount}{currencySymbol}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Final Amount:</th>
                                  <td>
                                    <span>{value.net_amount}{currencySymbol}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewInvoice;
